// extracted by mini-css-extract-plugin
export default {"container":"signup_container__tIKNa","wrapper":"signup_wrapper__NRyUs","mid":"signup_mid__VlSYp","loginForm":"signup_loginForm__552Eo"};